import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HelpService } from '../help.service';
import { TopicService } from '../topic.service';

@Component({
  selector: 'app-help-window',
  templateUrl: './help-window.component.html',
  styleUrls: ['./help-window.component.scss']
})
export class HelpWindowComponent implements OnInit {

  url$ = this.topicService.topic$
    .pipe(map(topicId => this.getUrl(topicId)));

  constructor(
    private topicService: TopicService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {

  }

  private getUrl(topicId): SafeResourceUrl {
    const url = `${environment.manual.url}/${topicId}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
